export type PickupCorporateDeadlineBucketKey =
  | 'three_hours_left'
  | 'two_hours_left'
  | 'one_hour_left'
  | 'late_one_hour'
  | 'late_two_hours'
  | 'late_over_three_hours'

export interface PickupCorporateDeadlineBucketItem {
  key: PickupCorporateDeadlineBucketKey
  label: string
  count: number
}

// Order & exact PRD labels
export const PICKUP_CORPORATE_DEADLINE_BUCKETS_CONFIG: Array<{
  key: PickupCorporateDeadlineBucketKey
  label: string
}> = [
  { key: 'three_hours_left', label: '>3 jam lagi' },
  { key: 'two_hours_left', label: '1-2 jam lagi' },
  { key: 'one_hour_left', label: '0-1 jam lagi' },
  { key: 'late_one_hour', label: 'Terlambat 0-1 jam' },
  { key: 'late_two_hours', label: 'Terlambat 1-2 jam' },
  { key: 'late_over_three_hours', label: 'Terlambat >3 jam' }
]

export function buildBucketItemsFromCounts(
  counts: Partial<Record<PickupCorporateDeadlineBucketKey, number>> = {}
): PickupCorporateDeadlineBucketItem[] {
  return PICKUP_CORPORATE_DEADLINE_BUCKETS_CONFIG.map((config) => ({
    key: config.key,
    label: config.label,
    count: counts[config.key] ?? 0
  }))
}
